import tenantApi from '@api';
import { Divider, Row } from 'antd';
import cx from 'clsx';
import React, { useMemo, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import styled, { css } from 'styled-components';
import { getUniqueArrayByObjKey } from '../../../utility/utility';
import {
  Button,
  Checkbox,
  ConfirmationModal,
  EmptyState,
  ErrorMessage,
  Group,
  ImageUploadDropzone,
  ListItem,
  Skeleton,
  TextWithIcon,
} from '../../common';
import Label from '../../common/Label/Label';
import { IconStyled } from '../../common/icon/IconStyled';
import Icon from '../../common/icon/icon';
import { CoverChip, DragHandle, FieldIconBox, ImageUpload, Remove, Thumbnail } from '../../common/image-uploads/styled';
import tenantConstants from '@constants';
import MediaGalleryModal from '../media-gallery/media-gallery-modal';
import { EmptyNoImage } from '../../svg';
import { ImageSelector } from './styled';
import QualityTip from '../quality-tip/quality-tip';
import tenantTheme from '@theme';
import { useLazyGetImageBankQuery } from '../../../apis/common';
import { v2Color } from '@theme/v2';

const ImagesSVG = ({ width = 64, height = 50 }) => (
  <svg width={width} height={height} viewBox="0 0 64 50" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_img_upload)">
      <path d="M27.3578 8.55343L7.66978 15.6481C5.98253 16.2561 5.10764 18.1168 5.71565 19.8041L12.8103 39.492C13.4184 41.1793 15.279 42.0542 16.9663 41.4462L36.6542 34.3515C38.3415 33.7435 39.2164 31.8828 38.6084 30.1955L31.5137 10.5076C30.9057 8.82031 29.045 7.94542 27.3578 8.55343Z" stroke={v2Color('#A6C8CA')} strokeWidth="1.80408"/>
      <path d="M13.1505 39.3691L17.9963 29.0633C18.3779 28.2518 19.345 27.9033 20.1565 28.2849L22.7591 29.5086C23.5706 29.8902 24.5378 29.5417 24.9193 28.7301L29.5085 18.9702C29.8901 18.1586 30.8572 17.8101 31.6687 18.1917L34.5862 19.5635" stroke={v2Color('#A6C8CA')} strokeWidth="1.80408" strokeLinecap="round"/>
      <path d="M16.403 22.856C17.5278 22.4507 18.1111 21.2103 17.7057 20.0854C17.3004 18.9606 16.06 18.3773 14.9351 18.7827C13.8103 19.188 13.227 20.4285 13.6324 21.5533C14.0377 22.6781 15.2782 23.2614 16.403 22.856Z" stroke={v2Color('#A6C8CA')} strokeWidth="1.80408"/>
    </g>
    <g clipPath="url(#clip1_img_upload)">
      <path d="M56.1545 10.4242L35.8888 5.20364C34.1521 4.75624 32.3815 5.80147 31.9341 7.53823L26.7135 27.8039C26.2661 29.5406 27.3114 31.3112 29.0481 31.7586L49.3138 36.9792C51.0505 37.4266 52.8211 36.3813 53.2685 34.6446L58.4891 14.3789C58.9365 12.6422 57.8912 10.8716 56.1545 10.4242Z" fill="#F5F9FF" stroke={v2Color('#A6C8CA')} strokeWidth="1.80408"/>
      <path d="M27.0624 27.8952L36.8693 22.1059C37.6415 21.65 38.637 21.9065 39.0929 22.6787L40.5549 25.1553C41.0107 25.9275 42.0063 26.184 42.7785 25.7281L52.066 20.2454C52.8383 19.7896 53.8338 20.046 54.2897 20.8182L55.9285 23.5945" fill="#F5F9FF"/>
      <path d="M27.0624 27.8952L36.8693 22.1059C37.6415 21.65 38.637 21.9065 39.0929 22.6787L40.5549 25.1553C41.0107 25.9275 42.0063 26.184 42.7785 25.7281L52.066 20.2454C52.8383 19.7896 53.8338 20.046 54.2897 20.8182L55.9285 23.5945" stroke={v2Color('#A6C8CA')} strokeWidth="1.80408" strokeLinecap="round"/>
      <path d="M39.0583 16.0782C40.2162 16.3764 41.3966 15.6796 41.6948 14.5218C41.9931 13.3639 41.2963 12.1835 40.1384 11.8853C38.9806 11.587 37.8002 12.2838 37.5019 13.4417C37.2037 14.5995 37.9005 15.7799 39.0583 16.0782Z" fill="#F5F9FF" stroke={v2Color('#A6C8CA')} strokeWidth="1.80408"/>
    </g>
    <path d="M45.6014 18.9707H24.6741C22.8806 18.9707 21.4268 20.4246 21.4268 22.218V43.1453C21.4268 44.9388 22.8806 46.3927 24.6741 46.3927H45.6014C47.3948 46.3927 48.8487 44.9388 48.8487 43.1453V22.218C48.8487 20.4246 47.3948 18.9707 45.6014 18.9707Z" fill="#F5F9FF" stroke={v2Color('#A6C8CA')} strokeWidth="1.80408"/>
    <path d="M21.7959 43.1453L29.8486 35.0926C30.4827 34.4585 31.5107 34.4585 32.1448 35.0926L34.1784 37.1262C34.8125 37.7603 35.8405 37.7603 36.4746 37.1262L44.1008 29.5C44.7349 28.8659 45.7629 28.8659 46.397 29.5L48.6766 31.7796" stroke={v2Color('#A6C8CA')} strokeWidth="1.80408" strokeLinecap="round"/>
    <path d="M30.4549 28.7126C31.6506 28.7126 32.6198 27.7433 32.6198 26.5477C32.6198 25.3521 31.6506 24.3828 30.4549 24.3828C29.2593 24.3828 28.29 25.3521 28.29 26.5477C28.29 27.7433 29.2593 28.7126 30.4549 28.7126Z" stroke={v2Color('#A6C8CA')} strokeWidth="1.80408"/>
    <defs>
      <clipPath id="clip0_img_upload">
        <rect width="34.6383" height="34.6383" fill="white" transform="translate(0 14.5791) rotate(-19.817)"/>
      </clipPath>
      <clipPath id="clip1_img_upload">
        <rect width="34.6383" height="34.6383" fill="white" transform="translate(30.1494) rotate(14.4456)"/>
      </clipPath>
    </defs>
  </svg>
);

const FromGallerySVG = () => (
  <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M5.88907 7.20869C6.3322 7.20869 6.73169 6.94169 6.90113 6.53244C7.07059 6.12268 6.97661 5.65183 6.66339 5.33861C6.35017 5.02538 5.87931 4.93141 5.46955 5.10086C5.06031 5.27032 4.7933 5.6698 4.7933 6.11293C4.79433 6.71781 5.28419 7.20767 5.88907 7.20869ZM5.88907 5.56556C6.11038 5.56556 6.31012 5.69854 6.39485 5.90342C6.47957 6.1083 6.43285 6.34348 6.27624 6.50009C6.11963 6.65722 5.88393 6.70395 5.67957 6.61922C5.47469 6.5345 5.34119 6.33475 5.34119 6.11292C5.3417 5.81048 5.58662 5.56556 5.88907 5.56556Z" fill={v2Color('#55969B')}/>
    <path d="M13.817 1.1493C13.5319 0.835389 13.1335 0.647892 12.7099 0.62932L4.22488 0.23514C3.80135 0.215371 3.3874 0.364537 3.07408 0.650284C2.76137 0.93544 2.57447 1.33381 2.5547 1.75735L2.50977 2.73143H1.83104C0.949219 2.73263 0.234564 3.44672 0.233337 4.32913V12.6363C0.234535 13.5181 0.949219 14.2322 1.83104 14.2334H10.1376C11.0194 14.2322 11.7341 13.5175 11.7353 12.6357V12.2865L12.1666 12.3068C12.1924 12.308 12.2175 12.3086 12.2433 12.3086C13.0964 12.308 13.7979 11.6365 13.8375 10.7846L14.2316 2.29954C14.2526 1.87601 14.1028 1.46202 13.817 1.1493ZM1.83106 3.37056H10.1382C10.6678 3.37116 11.0955 3.79949 11.0961 4.32905V8.14739C9.27499 8.09587 7.49157 8.67277 6.04662 9.78221C5.89865 9.89783 5.76086 10.017 5.62727 10.1374C5.3583 9.7834 5.04558 9.4653 4.69634 9.18973C3.60245 8.35764 2.24381 7.94968 0.872472 8.04253V4.32893C0.873071 3.79937 1.30209 3.37116 1.83106 3.37056ZM0.872565 12.6362V8.68185C2.10004 8.589 3.31972 8.94844 4.30091 9.69246C4.6286 9.95125 4.91914 10.2532 5.16536 10.5899C4.36861 11.4501 3.77255 12.4763 3.41905 13.5942H1.83102C1.30205 13.5936 0.873164 13.1652 0.872565 12.6362ZM10.1382 13.5947L4.09189 13.5941C4.54058 12.2888 5.3559 11.1404 6.43966 10.2862C7.77197 9.26356 9.4176 8.73401 11.0961 8.78672V12.6357C11.0955 13.1647 10.6678 13.5941 10.1382 13.5947ZM13.1994 10.7557C13.1887 11.0097 13.0754 11.2482 12.8867 11.4195C12.7004 11.592 12.4512 11.6819 12.1966 11.6681L11.7353 11.6465V4.32899C11.7341 3.44717 11.02 2.73252 10.1382 2.73129H3.14966L3.19279 1.78657C3.20417 1.53257 3.3168 1.29355 3.50489 1.12221C3.69301 0.95088 3.94102 0.861625 4.19501 0.873602L12.6801 1.26778C12.9341 1.27916 13.1731 1.39179 13.3444 1.57928C13.5158 1.7674 13.605 2.01541 13.5936 2.2694L13.1994 10.7557Z" fill={v2Color('#55969B')} stroke={v2Color('#55969B')} strokeWidth="0.466667"/>
  </svg>
);

const DropZoneBox = styled.div`
  width: 100%;
  height: ${(props) => (props.$mobile ? '160px' : '218px')};
  border-radius: 6px;
  background-color: ${v2Color('#f2fafa')};
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='100%25' height='100%25'%3E%3Crect width='100%25' height='100%25' rx='6' ry='6' fill='none' stroke='%23DDEAEB' stroke-width='1' stroke-dasharray='6%2C4'/%3E%3C%2Fsvg%3E");
  /* Triple-& to outrank the global '.dzu-dropzone.noImage > div { display: block }'
     rule (style.less) which would otherwise break the centered column layout on mobile. */
  &&& {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 12px;
  }
`;

const ImagesGrid = styled.div`
  && .gallery-thumb {
    width: ${props => props.$w ?? props.$size}px;
    height: ${props => props.$h ?? props.$size}px;
    border-radius: 6px;
    overflow: hidden;
  }
  && .gallery-thumb img {
    --thumbnail-width: ${props => props.$w ?? props.$size}px;
    --thumbnail-height: ${props => props.$h ?? props.$size}px;
  }
  /* compactPreview: smaller thumbnail controls to suit the 96 x 88 tiles. */
  ${(props) =>
    props.$compact &&
    css`
      && .gallery-thumb ${DragHandle} {
        inset-block-start: 4px;
        inset-inline-start: 4px;
      }
      && .gallery-thumb ${DragHandle} svg {
        width: 16px;
        height: 12px;
      }
      && .gallery-thumb ${Remove} {
        inset-block-start: 4px;
        inset-inline-end: 4px;
        width: 16px;
        min-width: 16px;
        height: 16px;
      }
      && .gallery-thumb ${Remove} svg {
        width: 8px;
        height: 8px;
      }
      && .gallery-thumb ${CoverChip} {
        inset-block-end: 4px;
        inset-inline-start: 4px;
        width: auto;
        height: 16px;
        padding: 0 6px;
        font-size: 10px;
        font-weight: 500;
      }
    `}
`;

// compactPreview: the add tile and the "+N" tile, same footprint as a thumbnail.
const CompactTile = styled.div`
  position: relative;
  width: ${(p) => p.$w}px;
  height: ${(p) => p.$h}px;
  flex: none;
  border-radius: 6px;
  overflow: hidden;
`;
const MoreTile = styled(CompactTile).attrs({ as: 'button', type: 'button' })`
  display: block;
  padding: 0;
  border: none;
  background: #ededed center / cover no-repeat;
  outline: 1px #f0f0f0 solid;
  outline-offset: -1px;
  cursor: pointer;
  font-family: inherit;
  &::after {
    content: attr(data-count);
    position: absolute;
    inset: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    background: rgba(23, 26, 31, 0.55);
    color: white;
    font-size: 13px;
    font-weight: 700;
  }
`;

const AddPlusSVG = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
    <path d="M8 3v10M3 8h10" stroke="#28B16D" strokeWidth="1.6" strokeLinecap="round" />
  </svg>
);

// Preview URL of an image item (uploaded or local).
const previewUrlOf = (img) =>
  img?.medium || img?.thumbnail || img?.sizes?.medium || img?.sizes?.thumbnail || img?.gallerythumb || img?.large || img?.url || img?.localPreview || null;

const ImageSelect = (props) => {
  const {
    label,
    labelIcon,
    values,
    setFieldValue,
    style,
    errorMsg,
    valueKey = 'property_images',
    filesAllowed,
    imageBankIcon = true,
    showImageBank = true,
    onImageUpload = () => {},
    showQualityTip = false,
    propertyTypeId,
    showClose = true,
    // Opt-in compact layout (Listings V2 drawer): { width, height, visible }. An add tile first, the
    // first `visible` thumbnails at width x height, then a "+N" tile that expands to show them all.
    // No header, dropzone or hints. Unset (the post-listing form) keeps the full layout.
    compactPreview = null,
  } = props;
  const [expanded, setExpanded] = useState(false);
  const [images, setImages] = useState([]);
  const [pagination, setPagination] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [showModal, setShowModal] = useState(false);
  const { t } = useTranslation();
  const redesignForm = !!tenantConstants?.FORM;
  const imageCount = (values[valueKey] || []).filter((img) => !img?._destroy).length;
  const hasImages = redesignForm && (!!imageCount || !!compactPreview);
  const [galleryOpen, setGalleryOpen] = useState(false);
  const [galleryInitialIndex, setGalleryInitialIndex] = useState(0);
  const [getImageBank] = useLazyGetImageBankQuery();
  // Drag-gate: react-easy-sort starts a drag on the very first mousemove after mousedown
  // (no threshold), which hijacks quick clicks — hiding the thumbnail (the "shrink") and
  // swallowing the click so the preview never opens. We swallow mousemove until the pointer
  // has actually moved past DRAG_THRESHOLD_PX so a click stays a click and reordering still works.
  const DRAG_THRESHOLD_PX = 6;
  const dragGate = useRef(null);
  // react-easy-sort appends the floating drag clone to document.body by default, which detaches it
  // from ImagesGrid and drops the `&& .gallery-thumb` size rules (clone shrinks to the intrinsic
  // 96px). Holding the clone inside ImagesGrid keeps those rules applying so it stays full size.
  const imagesGridRef = useRef(null);

  const user = useSelector((state) => state.app.loginUser.user);
  const isMobile = useSelector((state) => state.app.AppConfig.isMobile);

  const setImagesOnChange = () => {
    if (images.length) {
      setImages((prev) =>
        prev.map((e) => ({
          ...e,
          ...(values?.[valueKey].find((it) => it.id == e.id) ? { selected: true } : { selected: false }),
        })),
      );
    }
  };

  const fetchImages = async (page) => {
    setLoading(true);

    const response = await getImageBank({ userId: user.id, perPage: 30, page: page });
    if (response) {
      setLoading(false);
      if (response.error) {
        setError(response.error);
      } else {
        const imagesResponse = response.data.images;
        // if (values?.[valueKey] && values?.[valueKey]?.length) {
        //   values?.[valueKey].forEach((e) => {
        //     const selectedImage = imagesResponse.find((it) => it.id == e.id);
        //     if (selectedImage) selectedImage.selected = true;
        //   });
        // }
        setImages((prev) => [...prev, ...imagesResponse]);
        setPagination(response.data.pagination);
      }
    }
  };

  const onDone = () => {
    const selectedImages = images
      .filter((e) => e.selected)
      .map((e) => ({ ...e, uploaded: true, uploading: false, inError: false }));
    const allImages = values?.[valueKey]
      ? getUniqueArrayByObjKey([...values?.[valueKey], ...selectedImages], 'id')
      : [...selectedImages];
    if (!allImages.find((e) => e.isMainImage) && allImages[0]?.id) {
      allImages[0] = { ...allImages[0], isMainImage: true };
    }
    setFieldValue(valueKey, allImages);
    setShowModal(false);
  };

  return (
    <div name={valueKey}>
      {/* Bayut redesign shows a 32x32 gray-box field icon; the content track is
          `minmax(0, 1fr)` so the thumbnail grid wraps inside the 640px section instead
          of a `max-content`/`auto` track stretching to fit every thumbnail on one row. */}
      <Group
        template={redesignForm && !compactPreview ? 'max-content minmax(0, 1fr)' : labelIcon ? 'max-content auto' : 'minmax(0, 1fr)'}
        gap="16px"
        style={{ ...style }}
      >
        {compactPreview ? null : redesignForm ? (
          <FieldIconBox $mobile={isMobile}>
            <Icon icon={labelIcon || 'LuImage'} color="#707070" size={isMobile ? 14 : 17} />
          </FieldIconBox>
        ) : (
          labelIcon && (
            <IconStyled>
              <Icon icon={labelIcon} />
            </IconStyled>
          )
        )}
        <div style={{ minWidth: 0 }}>
          <Group template="initial" gap="8px" className={compactPreview ? undefined : 'mb-16'} style={{ minWidth: 0 }}>
            {redesignForm ? (
              <>
                {/* Always visible: title + description (not in the compact preview) */}
                {!compactPreview && (
                  <div style={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 8 }}>
                      <Label {...(isMobile ? { size: 'small', color: '#222222', fontWeight: 700 } : {})}>{label}</Label>
                      {isMobile && imageCount > 0 && (
                        <span
                          style={{
                            display: 'inline-flex',
                            alignItems: 'center',
                            gap: 4,
                            height: 22,
                            padding: '4px 8px',
                            borderRadius: 4,
                            background: '#F5F5F5',
                            flexShrink: 0,
                          }}
                        >
                          <Icon icon="IconImageCount" size={12} />
                          <span style={{ fontSize: 12, fontWeight: 600, color: '#222222', lineHeight: '14px' }}>
                            {imageCount}
                          </span>
                        </span>
                      )}
                    </div>
                    <p
                      style={{
                        fontSize: isMobile ? 12 : 14,
                        fontWeight: 400,
                        color: '#9D9D9D',
                        margin: 0,
                        lineHeight: isMobile ? '18px' : '21.99px',
                      }}
                    >
                      {t('Great images sell faster! Add at-least 5 clear images (Max 15MB). Drag to reorder. First image is the cover.')}
                    </p>
                  </div>
                )}
                {!hasImages ? (
                  /* ── No-image state ── */
                  <ImageUploadDropzone
                    btnClassName=""
                    btnText={isMobile ? t('Upload from gallery') : t('Upload Images')}
                    btnStyle={{
                      backgroundColor: v2Color('#006169'),
                      color: '#fff',
                      height: 36,
                      borderRadius: 6,
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      cursor: 'pointer',
                      boxShadow: 'none',
                      textShadow: 'none',
                      whiteSpace: 'nowrap',
                      ...(isMobile
                        ? { width: 148, fontSize: 12, fontWeight: 700, padding: '6px 12px' }
                        : { minWidth: 158, fontSize: 14, fontWeight: 600, padding: '6px 30.66px' }),
                    }}
                    pictures={values[valueKey] || []}
                    setPictures={(pictures) => setFieldValue(valueKey, pictures)}
                    previewKey="medium"
                    fullPreviewKey="large"
                    selectMainOnDoubleClick={true}
                    name={valueKey}
                    filesAllowed={filesAllowed}
                    attachmentType="listing_image"
                    containerClass={cx(isMobile && 'noImage')}
                    onImageUpload={onImageUpload}
                    showClose={showClose}
                    redesign={redesignForm}
                  >
                    {(_, renderUploadButton) => (
                      <DropZoneBox $mobile={isMobile}>
                        <ImagesSVG {...(isMobile ? { width: 50.95, height: 40 } : {})} />
                        {isMobile ? (
                          <p style={{ fontSize: 12, fontWeight: 400, color: '#626262', margin: 0 }}>
                            {t('Browse for images in your gallery')}
                          </p>
                        ) : (
                          <>
                            <p style={{ fontSize: 16, fontWeight: 700, color: '#222222', margin: 0 }}>
                              {t('Drop Images')}
                            </p>
                            <p style={{ fontSize: 12, fontWeight: 400, color: '#626262', margin: 0 }}>
                              {t('or browse for images')}
                            </p>
                          </>
                        )}
                        {renderUploadButton()}
                      </DropZoneBox>
                    )}
                  </ImageUploadDropzone>
                ) : (
                  /* ── Has-images state ── */
                  <ImageUploadDropzone
                    btnClassName=""
                    btnText={
                      compactPreview ? (
                        <AddPlusSVG />
                      ) : isMobile ? (
                        <span style={{ display: 'inline-flex', alignItems: 'center', gap: 8 }}>
                          <FromGallerySVG />
                          <span style={{ fontSize: 12, fontWeight: 600, color: v2Color('#006169', 'text') }}>{t('From Gallery')}</span>
                        </span>
                      ) : (
                        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 4 }}>
                          <ImagesSVG width={60} height={60} />
                          <span style={{ fontSize: 14, fontWeight: 600, color: '#222222' }}>{t('Add more')}</span>
                        </div>
                      )
                    }
                    btnStyle={
                      compactPreview
                        ? {
                            width: compactPreview.width,
                            height: compactPreview.height,
                            minWidth: 0,
                            padding: 0,
                            borderRadius: 6,
                            border: '1.5px dashed #D4EFE2',
                            background: 'white',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            boxShadow: 'none',
                            textShadow: 'none',
                            cursor: 'pointer',
                            flexShrink: 0,
                          }
                        : isMobile
                        ? {
                            width: 151.5,
                            height: 38,
                            minWidth: 0,
                            padding: '12px 16px',
                            borderRadius: 4,
                            border: `0.82px dashed ${v2Color('#DDEAEB')}`,
                            background: v2Color('#F2FAFA'),
                            display: 'inline-flex',
                            flexDirection: 'row',
                            alignItems: 'center',
                            justifyContent: 'center',
                            gap: 8,
                            boxShadow: 'none',
                            textShadow: 'none',
                            cursor: 'pointer',
                          }
                        : {
                            width: 170,
                            height: 170,
                            backgroundColor: v2Color('#F2FAFA'),
                            border: `1px dashed ${v2Color('#DDEAEB')}`,
                            borderRadius: 6,
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            padding: 0,
                            cursor: 'pointer',
                            boxShadow: 'none',
                            flexShrink: 0,
                          }
                    }
                    pictures={values[valueKey] || []}
                    setPictures={(pictures) => setFieldValue(valueKey, pictures)}
                    previewKey="medium"
                    fullPreviewKey="large"
                    selectMainOnDoubleClick={true}
                    name={valueKey}
                    filesAllowed={filesAllowed}
                    attachmentType="listing_image"
                    containerClass=""
                    onImageUpload={onImageUpload}
                    showClose={showClose}
                    redesign={redesignForm}
                    holderRef={imagesGridRef}
                  >
                    {(renderImages, renderUploadButton) => (
                      <>
                      <div
                        style={{ display: 'flex', flexWrap: 'wrap', gap: 8, alignItems: 'flex-start' }}
                        onMouseDown={(e) => {
                          if (e.button !== 0) return;
                          dragGate.current = { x: e.clientX, y: e.clientY, armed: false };
                        }}
                        onMouseMove={(e) => {
                          const g = dragGate.current;
                          // Only gate while the left button is held and a drag hasn't been armed yet.
                          if (!g || g.armed || e.buttons !== 1) return;
                          const dx = e.clientX - g.x;
                          const dy = e.clientY - g.y;
                          if (dx * dx + dy * dy < DRAG_THRESHOLD_PX * DRAG_THRESHOLD_PX) {
                            // Below threshold: stop the move from reaching react-easy-sort's
                            // document listener so it doesn't kick off a drag on a click.
                            e.stopPropagation();
                          } else {
                            // Past threshold: real drag intent — let it (and all later moves) through.
                            g.armed = true;
                          }
                        }}
                        onClick={(e) => {
                          // A drag occurred (thumbnails were reordered) — don't treat it as a click.
                          if (dragGate.current?.armed) {
                            dragGate.current = null;
                            return;
                          }
                          dragGate.current = null;
                          const imageItem = e.target.closest('[data-image-id]');
                          if (!imageItem) return;
                          const imageId = imageItem.getAttribute('data-image-id');
                          const getUrl = (img) => img?.large || img?.gallerythumb || img?.url || img?.thumbnail || img?.image || img?.imageURL || img?.sizes?.full || img?.localPreview || null;
                          const usable = (values[valueKey] || []).filter(
                            (img) => !img?.inError && !img?._destroy && getUrl(img),
                          );
                          const idx = usable.findIndex((img) => String(img.id) === imageId);
                          setGalleryInitialIndex(idx >= 0 ? idx : 0);
                          setGalleryOpen(true);
                        }}
                      >
                        {compactPreview ? (
                          <ImagesGrid ref={imagesGridRef} $w={compactPreview.width} $h={compactPreview.height} $compact>
                            {(() => {
                              const visibleImages = (values[valueKey] || []).filter((img) => !img?._destroy);
                              const limit = compactPreview.visible ?? 3;
                              const collapsed = !expanded && visibleImages.length > limit;
                              const more = collapsed ? (
                                <MoreTile
                                  $w={compactPreview.width}
                                  $h={compactPreview.height}
                                  data-count={`+${visibleImages.length - limit}`}
                                  aria-label={t('Show all images')}
                                  style={{ backgroundImage: previewUrlOf(visibleImages[limit]) ? `url("${previewUrlOf(visibleImages[limit])}")` : undefined }}
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    setExpanded(true);
                                  }}
                                />
                              ) : null;
                              return renderImages(more, { leadingElement: renderUploadButton(), maxVisible: collapsed ? limit : undefined });
                            })()}
                          </ImagesGrid>
                        ) : (
                          <ImagesGrid ref={imagesGridRef} $size={isMobile ? 84 : 170}>
                            {renderImages(isMobile ? undefined : renderUploadButton())}
                          </ImagesGrid>
                        )}
                      </div>
                      {compactPreview && expanded && (values[valueKey] || []).filter((img) => !img?._destroy).length > (compactPreview.visible ?? 3) && (
                        <button
                          type="button"
                          onClick={() => setExpanded(false)}
                          style={{ alignSelf: 'flex-start', marginTop: 8, padding: 0, border: 'none', background: 'none', color: '#208E57', fontSize: 12, fontWeight: 600, cursor: 'pointer', fontFamily: 'inherit' }}
                        >
                          {t('Show less')}
                        </button>
                      )}
                      {isMobile && !compactPreview && <div style={{ marginTop: 4 }}>{renderUploadButton()}</div>}
                      </>
                    )}
                  </ImageUploadDropzone>
                )}
              </>
            ) : (
              /* ── Original (non-redesign) layout ── */
              <>
                <Label>{label}</Label>
                <ImageUpload>
                  <ImageUploadDropzone
                    btnText={t('Upload Images')}
                    btnStyle={
                      !isMobile && {
                        padding: '6px 14px',
                        color: '#fff',
                        backgroundColor: tenantTheme['primary-color'],
                      }
                    }
                    pictures={values[valueKey] || []}
                    setPictures={(pictures) => setFieldValue(valueKey, pictures)}
                    previewKey="medium"
                    fullPreviewKey="large"
                    selectMainOnDoubleClick={true}
                    name={valueKey}
                    filesAllowed={filesAllowed}
                    attachmentType="listing_image"
                    containerClass={cx(!values[valueKey]?.length && isMobile && 'noImage')}
                    onImageUpload={onImageUpload}
                    showClose={showClose}
                  >
                    {(renderImages, renderUploadButton) => (
                      <>
                        <Row style={{ rowGap: '16px', columnGap: '32px' }} className="align-items-center">
                          {imageBankIcon && <Icon icon="IconImageBank" />}
                          <Group template="initial" gap="8px" style={{ alignSelf: isMobile && 'start' }}>
                            {renderUploadButton()}
                            {showImageBank ? (
                              <Button
                                onClick={() => {
                                  !images.length && fetchImages();
                                  setShowModal(true);
                                  setImagesOnChange();
                                }}
                              >
                                {t('Image Bank')}
                              </Button>
                            ) : (
                              <></>
                            )}
                            {!isMobile && (
                              <small className="color-gray-dark" style={{ width: '22ch' }}>
                                {t(tenantConstants.LISTING_IMAGE_SIZE_HINT || 'Max size 15MB, .jpg .png only')}
                              </small>
                            )}
                          </Group>
                          {!isMobile && (
                            <ul className={cx('text-muted', !!values[valueKey]?.length ? '' : 'mb-0')} style={{ flex: 1 }}>
                              <ListItem className="flex mb-8" style={{ gap: '6px' }}>
                                {t('Ads with pictures get 5x more views.')}
                              </ListItem>
                              <ListItem className="flex mb-8" style={{ gap: '6px' }}>
                                {t('Upload good quality pictures with proper lighting.')}
                              </ListItem>
                              <ListItem className="flex" style={{ gap: '6px' }}>
                                {t('Double click to set cover image.')}
                              </ListItem>
                            </ul>
                          )}
                        </Row>
                        {!!values[valueKey]?.length && (
                          <>
                            {!isMobile && <Divider style={{ marginBlock: '20px 16px' }} />}
                            {renderImages()}
                          </>
                        )}
                      </>
                    )}
                  </ImageUploadDropzone>
                </ImageUpload>
                {!!values[valueKey]?.length && isMobile && (
                  <TextWithIcon
                    icon="FiInfo"
                    title={t('Double click to set cover image.')}
                    textColor="#A3A3A3"
                    fontWeight={400}
                    className="fs12"
                    iconProps={{
                      size: 13,
                      color: '#A3A3A3',
                    }}
                  />
                )}
              </>
            )}
            <ErrorMessage message={errorMsg} />
          </Group>
          {showQualityTip && (
            <QualityTip
              type="images"
              count={(values?.[valueKey] || []).filter((image) => !image._destroy).length}
              propertyId={propertyTypeId}
            />
          )}
        </div>
      </Group>

      <ConfirmationModal
        title={t('Upload From Image Bank')}
        visible={showModal}
        onCancel={() => setShowModal(false)}
        onSuccess={onDone}
      >
        {loading && !images.length ? (
          <Group template="repeat(auto-fill,minmax(min(96px,100%),1fr))" gap="8px">
            {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map((e) => (
              <Skeleton width="100%" height={96} key={e} />
            ))}
          </Group>
        ) : error && !images.length ? (
          <EmptyState message={error} onClick={fetchImages} buttonLoading={loading} />
        ) : (
          <>
            {images.length ? (
              <>
                <Group
                  template="repeat(auto-fill,minmax(min(96px,100%),1fr))"
                  gap="8px"
                  className="scroll-y"
                  style={{ '--box-height': '408px', padding: 2 }}
                >
                  {images.map((item, index) => (
                    <ImageSelector key={index}>
                      <Checkbox
                        value={item.selected}
                        onChange={(event) => {
                          setImages((prev) => {
                            const updatedImages = [...prev];
                            updatedImages[index] = { ...updatedImages[index], selected: event.target.checked };
                            return updatedImages;
                          });
                        }}
                        style={{ width: '100%', height: 96 }}
                      >
                        <Thumbnail style={{ '--thumbnail-width': '100%' }} src={item.thumbnail} />
                      </Checkbox>
                    </ImageSelector>
                  ))}
                </Group>
                {pagination?.nextPage && (
                  <Row justify="center" style={{ marginTop: 8 }}>
                    <Button
                      type={'link'}
                      // loading={loading}
                      disabled={loading}
                      onClick={() => fetchImages(pagination.nextPage)}
                    >
                      {images.length && error ? 'Retry' : `Show More`}
                      <Icon icon="MdKeyboardArrowDown" className="m-0" />
                    </Button>
                  </Row>
                )}
              </>
            ) : (
              <EmptyState illustration={<EmptyNoImage />} title={t('No Images Uploaded')} hideRetryButton />
            )}
          </>
        )}
      </ConfirmationModal>

      {redesignForm && (
        <MediaGalleryModal
          visible={galleryOpen}
          initialTab="images"
          initialIndex={galleryInitialIndex}
          onClose={() => setGalleryOpen(false)}
          images={values?.[valueKey] || []}
          videos={values?.videos || []}
        />
      )}
    </div>
  );
};

export default ImageSelect;
